























































import Vue from 'vue';

export default Vue.extend({
  'name': 'AdminChangeRequests',
  data () {
    return {
      'loading': false,
      'error': null as string | null,
      'rows': [] as any[],
      'statusFilter': 'Processing',
      'actingId': 0 as number
    };
  },
  'methods': {
    refresh () {
      this.loading = true;
      this.error = null;
      this.axios.get('warranty/change-requests', { 'params': { 'status': this.statusFilter } })
        .then((res: any) => { this.rows = res.data.result || []; })
        .catch((e: any) => { this.error = e?.response?.data?.message || 'Failed to load change requests.'; })
        .finally(() => { this.loading = false; });
    },
    act (row: any, action: 'approve' | 'reject') {
      // Determine endpoint by request type.
      const verbBase = row.type === 'Delete' ? 'delete'
        : row.type === 'ReassignCustomer' ? 'reassign'
          : row.type === 'Modify' ? 'modify'
            : null;
      if (!verbBase) {
        alert('Unknown request type: ' + row.type);
        return;
      }
      if (!confirm(`${action === 'approve' ? 'Approve' : 'Reject'} this ${row.type} request?`)) return;

      this.actingId = row.id;
      this.axios.put(`warranty/${verbBase}/${action}`, null, { 'params': { 'warrantyDetailId': row.warrantyDetailId } })
        .then(() => { this.refresh(); })
        .catch((e: any) => { alert(e?.response?.data?.message || 'Action failed.'); })
        .finally(() => { this.actingId = 0; });
    },
    formatDate (s: string): string {
      if (!s) return '—';
      const d = new Date(s);
      const pad = (n: number) => String(n).padStart(2, '0');
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
    }
  },
  mounted () { this.refresh(); }
});
